"use client";

import { useRouter } from "next/navigation";
import { toast } from "sonner";
import clsx from "clsx";
import { Minus, Plus } from "lucide-react";
import { updateItemQuantity } from "@/lib/shopify/actions/cart";
import type { CartItem } from "lib/shopify/types";

function SubmitButton({ type }: { type: "plus" | "minus" }) {
  return (
    <button
      type="submit"
      aria-label={
        type === "plus" ? "Menge erhöhen" : "Menge verringern"
      }
      className={clsx(
        "ease flex h-full min-w-[36px] max-w-[36px] flex-none items-center justify-center rounded-full p-2 transition-all duration-200 hover:border-neutral-800 hover:opacity-80",
        {
          "ml-auto": type === "minus",
        },
      )}
    >
      {type === "plus" ? (
        <Plus className="h-[2rem] w-[2rem] dark:text-neutral-500 ms-2" />
      ) : (
        <Minus className="h-[1.75rem] w-[1.75rem] dark:text-neutral-500" />
      )}
    </button>
  );
}

export function EditItemQuantityButton({
  item,
  type,
  optimisticUpdate,
}: {
  item: CartItem;
  type: "plus" | "minus";
  optimisticUpdate: any;
}) {
  const router = useRouter();
  const payload = {
    merchandiseId: item.merchandise.id,
    quantity: type === "plus" ? item.quantity + 1 : item.quantity - 1,
  };

  const submit = async () => {
    if (type === "plus" && payload.quantity > 10) {
      toast.error("Maximale Menge erreicht");
      return;
    }

    optimisticUpdate(payload.merchandiseId, type);
    const error = await updateItemQuantity(null, payload);
    if (error) toast.error(error);
    router.refresh();
  };

  return (
    <form action={submit}>
      <SubmitButton type={type} />
    </form>
  );
}
